export default {"src":"/_next/static/media/fh-404-150.9f6f3db6.svg","height":56,"width":150,"blurWidth":0,"blurHeight":0};